import { combineReducers, createStore, compose } from 'redux';
import alertReducer from './reducers/alertReducer';
import alertConfirmReducer from './reducers/alertConfirmReducer';
import styleNameReducer from './reducers/styleNameReducer';
import callCompleteReducer from './reducers/callCompletedReducer';
import retryReceiptReducer from './reducers/retryReceiptReducer';

//dev only
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const rootReducer = combineReducers({
    commonAlerts: alertReducer,
    confirmAlert: alertConfirmReducer,
    styleNames: styleNameReducer,
    callComplete: callCompleteReducer,
    retryReceipt: retryReceiptReducer
});

export const store = createStore(rootReducer 
    //composeEnhancers() //dev only
    );